import request from '@/utils/request'

export default {
  getHotelsMapByLocation (params, cancelToken) {
    return request({
      cancelToken: cancelToken.token,
      url: '/hotels/location',
      method: 'get',
      params: params
    })
  },
  getHotels (params, cancelToken) {
    return request({
      cancelToken: cancelToken.token,
      url: `/hotels`,
      method: 'get',
      params: params
    })
  },
  getHotelsV3 (params, cancelToken) {
    return request({
      cancelToken: cancelToken.token,
      url: `${process.env.VUE_APP_API}/v3/search/list`,
      method: 'get',
      params: {
        ...params,
        owlmapId: params.searchId
      }
    })
  },
  getDefaultSeachList (params) {
    return request({
      url: `${process.env.VUE_APP_API}/v3/search/list/default`,
      method: 'get',
      params: {
        ...params
      }
    })
  },
  // !Important Stage 需要加上V2
  getHotel (hotelId) {
    return request({
      url: `/hotels/${hotelId}`,
      method: 'get'
    })
  },
  getAllowances () {
    return request({
      url: `/allowances`,
      method: 'get'
    })
  },
  getHotelV3 (hotelId, source) {
    return request({
      url: `${process.env.VUE_APP_API}/v3/hotels/${source}/${hotelId}`,
      method: 'get'
    })
  },
  getHotelInventoryV3 (params) {
    return request({
      url: `${process.env.VUE_APP_API}/v3/hotels/inventory`,
      method: 'get',
      params
    })
  },
  getHotelInventoryLowestPriceV3 (params) {
    return request({
      url: `${process.env.VUE_APP_API}/v3/hotels/inventory/price`,
      method: 'get',
      params
    })
  },
  getHotelRooms (params, cancelToken) {
    const { hotelId } = params
    return request({
      cancelToken: cancelToken.token,
      url: `/hotels/${hotelId}/rooms`,
      method: 'get',
      params: params
    })
  },
  getHotelTripAdvisorReview (hotelUuid) {
    return request({
      url: `/hotels/${hotelUuid}/tripadvisor`,
      method: 'get'
    })
  },
  fetchHotelNearby (params) {
    return request({
      url: `${process.env.VUE_APP_API}/v3/search/nearby`,
      methed: 'get',
      params
    })
  }
}
